import React from 'react';

const WhatsAppBubble = ({ phoneNumber, message }) => {
  if (!phoneNumber) return null;

  const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
  const encodedMessage = encodeURIComponent(message || 'Hola, necesito ayuda');
  const whatsappUrl = `https://wa.me/${cleanNumber}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-200 hover:shadow-xl"
      data-testid="whatsapp-bubble"
      aria-label="Contactar por WhatsApp"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958a15.9 15.9 0 008.832 2.664C24.826 31.996 32 24.82 32 16.004 32 7.176 24.826 0 16.004 0zm9.334 22.606c-.39 1.1-2.286 2.104-3.15 2.154-.79.044-1.54.376-5.186-1.08-4.396-1.756-7.204-6.252-7.422-6.542-.212-.29-1.74-2.312-1.74-4.412 0-2.1 1.1-3.132 1.49-3.56.39-.428.852-.534 1.136-.534.284 0 .568.004.816.014.262.012.614-.1.96.732.356.852 1.21 2.952 1.316 3.166.106.214.178.464.036.748-.142.284-.214.462-.426.712-.214.248-.448.556-.64.746-.212.214-.434.446-.186.874.248.428 1.1 1.816 2.364 2.942 1.624 1.448 2.994 1.896 3.422 2.11.428.212.678.178.926-.106.248-.284 1.066-1.244 1.35-1.672.284-.428.568-.356.96-.214.39.142 2.488 1.174 2.916 1.388.428.214.712.32.818.498.106.178.106 1.028-.284 2.128z"/>
      </svg>
    </a>
  );
};

export default WhatsAppBubble;
